import React, { useEffect, useRef, useState } from 'react'
import noImage from "src/assets/images/noimage.png";
import NavigateToPDP from "src/component/Global/Product/NavigateToPDP";
import PlusMinusInputForOrderReturnReq from "src/component/PlusMinusInputForOrderReturnReq";
import DisplayLongDescriptionAndVariantMFRName from 'src/component/Product/DisplayLongDescriptionAndVariantMFRName';
import System from "src/helper/system";
import { useOrderStore } from "src/hooks/order";
import AlertContentWithFlag from "src/pages/Checkout/AlertContentWithFlag";
import { __remove, __set } from "src/store/axios_indicator";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import Helper from "src/support/Helper";
import { isNumber } from "underscore";

const OrderHistoryReturnRequestPopUp = (props) => {
    const { SetStatus, data } = props;
    const singleOrder = data.singleOrder
    const singleProduct = data.singleProduct
    const currentProd = {
        ERPMFRPartNumber: singleProduct?.manufacturerPartNumber,
        ERPPartNumber: singleProduct?.matnr,
        ItemNumber: singleProduct?.itemNumber,
        ShortDescription: singleProduct?.productShortDescription
    }
    const defaultModel = {
        quantity: 1,
        reason: "",
        file: [],
        comment: "",
    };
    const [searchData, setSearchData] = useState(defaultModel);
    const [orderReturnReason, setOrderReturnReason] = useState([])
    const [{ }, { fetch_order_return_reason }, { place_order_return_request }] = useOrderStore();
    const [detailValidation, setDetailValidation] = useState({});
    const [error, setError] = useState(false)
    const inputRef = useRef(null);
    const commentMaxLength = 500;
    const [__check] = useAxiosIndicatorCheck();
    const QtyMin = 1;
    useEffect(() => {
        async function fetchHere() {
            let res = await fetch_order_return_reason();
            if (res?.length > 0) {
                setOrderReturnReason(res);
            }
        }
        fetchHere()
    }, [])

    const onSubmit = async (e) => {
        setError(false);
        let isValid = onValidateData();
        if (isValid) {
            {
                const requestObj = {
                    ManufacturerPartNumber: singleProduct?.manufacturerPartNumber,
                    PurchaseOrderNumber: singleOrder?.purchaseOrderNumber,
                    WebOrderNumber: singleOrder?.webOrderNumber,
                    SapOrderNumber: singleOrder?.sapOrderNumber,
                    ShippedDate: Helper.getStandardDateFormat(singleOrder?.deliveryDate),
                    ShippedQuantity: singleOrder?.shippedQuantity,
                    ReturnQuantity: searchData?.quantity || 1,
                    ReturnReasonKey: searchData?.reason,
                    Comments: searchData?.comment,
                    LineItemNumber: singleOrder?.lineItemNumber,
                    ManufacturerCode: singleOrder?.erpManufacturerCode,
                    Files: searchData?.file
                }

                __set('ORDER_RETURN_REQUEST_API_CALL');
                let res = await place_order_return_request(requestObj);
                __remove('ORDER_RETURN_REQUEST_API_CALL');
                if (res?.isSuccessFull) {
                    System.popup('ThankYouPopup', { isOrderReturn: true });
                }
                else {
                    setError(true);
                }
            }
        }
    }

    const onValueChange = (field, value) => {
        if (detailValidation && Object.keys(detailValidation).length > 0) {
            delete detailValidation[field]
            if (detailValidation['comment']) { // reset validation for comment
                delete detailValidation['comment'];
            }
        }
        setSearchData({ ...searchData, [field]: value });
    }

    const onValidateData = () => {
        let validationModal = {}
        Helper.valueIsNotNull(searchData.reason) ? "" : validationModal.reason = "Selecting a reason is required.";
        if (searchData.reason === "Others" && !Helper.valueIsNotNull(searchData.comment)) {
            validationModal.comment = "Adding comment is required.";
        }
        setDetailValidation(validationModal)
        return Object.keys(validationModal).length > 0 ? false : true;
    }

    const handleChange = function (e) {
        e.preventDefault();
        if (e.target.files) {
            let inputObj = Array.from(e.target.files).map((x) => {
                return {
                    file: x,
                    isError: false
                }
            })
            validateReasonFiles(inputObj)
        }
    };

    const validateReasonFiles = (files, isRemove = false) => {
        let fileArr = searchData?.file?.length > 0 && !isRemove ? searchData?.file.concat(files) : files;
        if (!isRemove && (fileArr.length > 3)) {
            setDetailValidation({ ...detailValidation, 'file': 'Maximum 3 files allowed' });
        }
        else if (!isValidFileUploaded(files, isRemove)) {
            setDetailValidation({ ...detailValidation, 'file': 'Invalid file type. Permissible file type are pdf, doc(x), txt, csv, xls(x), image-files' });
        }
        else if (getFileSize(files, isRemove) > 20) {
            setDetailValidation({ ...detailValidation, 'file': 'Invalid file size. Total size of files cannot exceed 20MB' });
        }
        else {
            delete detailValidation['file'];
            setDetailValidation(detailValidation);
        }
    }

    const validateFileExtension = (extension) => {
        return ['png', 'jpeg', 'jpg', 'pdf', 'doc', 'txt', 'xlsx', 'csv', 'docx', 'xls'].includes(extension);
    }
    const isValidFileUploaded = (files, isRemove) => {
        let invalidCount = 0;
        if (files?.length > 0) {
            for (let i = 0; i < Array.from(files).length; i++) {
                const file = files[i]?.file;
                const fileExtension = file?.name.substring(file?.name.lastIndexOf('.') + 1)
                if (!validateFileExtension(fileExtension)) {
                    invalidCount++;
                }
                if (!isRemove) {
                    setSearchData(prevState => ({
                        ...prevState,
                        file: [...prevState.file, { file: file, isError: !validateFileExtension(fileExtension) }]
                    }));
                }
            }
        }
        return invalidCount > 0 ? false : true;
    }

    const getFileSize = (files, isRemove) => {
        let totalFileSize = 0;
        let fileArr = searchData?.file?.length > 0 && !isRemove ? files.concat(searchData?.file) : files;
        if (fileArr?.length > 0) {
            Array.from(fileArr).forEach(elem => {
                let size_in_mb = Helper.bytesToMB(elem?.file?.size);
                if (size_in_mb > 0) {
                    totalFileSize += size_in_mb;
                }
            });
        }
        return totalFileSize;
    }

    const removeFile = (indexToDelete) => {
        let remainingFiles = { ...searchData, file: searchData.file.filter((item, index) => index !== indexToDelete) };
        setSearchData(remainingFiles);
        validateReasonFiles(remainingFiles.file, true)
    }

    const validateDisableButton = () => {
        if (!isNumber(searchData?.quantity) ||
            (QtyMin && searchData?.quantity < QtyMin) ||
            (singleProduct?.shippedQuantity && searchData?.quantity > singleProduct?.shippedQuantity) ||
            (searchData?.quantity % QtyMin !== 0)) {
            return true;
        }
        if (Object.keys(detailValidation)?.length > 0) {
            return true;
        }
        return false;
    }
    return (
        <div>
            <div className="avnet-modal modal-1250">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close" data-dismiss="modal"
                        onClick={() => {
                            SetStatus(false)
                        }}>×
                    </button>
                    <div className="modal-header justify-content-center">
                        <h1 className="pcn-modal-heading ps-4 pe-4">
                            Return Request
                        </h1>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        {error &&
                            <AlertContentWithFlag message={'An error occurred sending your request, please try again. If the problem persists, please reach out to your sales contact for your request.'} type="danger" isDisplay={false} isDisplayIcon={true} />
                        }
                        <div className="clearfix" />
                        <form>
                            <div className="pt-2 pb-2">
                                <div className='return-request-container'>

                                    <h5 className='mb-3 font-18'><strong> Order Information</strong></h5>
                                    <div className='return-request-order'>
                                        <div className='font-13 font-arial'><b>PO Number </b>
                                            {singleOrder && singleOrder?.purchaseOrderNumber.trim() !== '' ? singleOrder.purchaseOrderNumber : '-'}
                                        </div>
                                        <div className='font-13 font-arial'><b>Web Order Number </b>
                                            {singleOrder && singleOrder?.webOrderNumber ? singleOrder.webOrderNumber : '-'}
                                        </div>
                                        <div className='font-13 font-arial'><b>Order Number </b>
                                            {singleOrder && singleOrder?.sapOrderNumber ? singleOrder.sapOrderNumber : '-'}
                                        </div>
                                        <div className='font-13 font-arial border-0'><b>Shipped Date </b>
                                            {singleOrder && singleOrder?.deliveryDate ? singleOrder.deliveryDate : '-'}
                                        </div>
                                    </div>
                                </div>
                                <div className='return-request-form mb-4'>
                                    <table className='table return-request-form-table'>
                                        <tbody>
                                            <tr>
                                                <td className='rr-prod-details border-0'>
                                                    <div className='d-flex align-items-center'>
                                                        <div className="product-img sect-1 text-center me-2">
                                                            {singleProduct && (
                                                                <img alt="Product"
                                                                    src={singleProduct.assetURL ? singleProduct.assetURL : noImage} />
                                                            )}
                                                        </div>
                                                        <div className="product-name">
                                                            {singleProduct && singleProduct?.itemNumber && singleProduct?.manufacturerPartNumber  && (
                                                                 <NavigateToPDP data={{
                                                                    ManufacturerName: singleProduct?.manufacturerName,
                                                                    ERPMFRPartNumber: singleProduct?.manufacturerPartNumber,
                                                                    ItemNumber: singleProduct?.itemNumber,
                                                                }} class="cursor-pointer text-wrap text-break">
                                                                  <p className='d-block mb-0 font-13 text-black'><strong>{singleProduct?.manufacturerPartNumber}</strong></p>
                                                                    <div className="font-12">
                                                                        <DisplayLongDescriptionAndVariantMFRName
                                                                            currentProduct={currentProd}
                                                                            no_show_more={true}
                                                                        />
                                                                    </div>
                                                             </NavigateToPDP>
                                                            )}
                                                           
                                                            {!(singleProduct?.itemNumber && singleProduct?.manufacturerPartNumber) &&
                                                                <p className='d-block mb-0 font-13 text-black'><strong>{Helper.valueIsNotNull(singleProduct?.manufacturerPartNumber) ? singleProduct?.manufacturerPartNumber : singleOrder?.manufacturerPartNumber }</strong></p>
                                                            }
                                                            <p className='d-block mb-0 font-13'><strong> Shipped Quantity:  {singleProduct?.shippedQuantity}</strong></p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className='rr-prod-quantity border-0'>
                                                    <div>
                                                        <p className='font-13 mb-0'><strong>Quantity to Return: </strong> </p>
                                                        <div className="quantity w-auto clearfix" id="Quantity">
                                                            <div className="quantity-picker">
                                                                <PlusMinusInputForOrderReturnReq
                                                                    name="quantity" type="text"
                                                                    force_default_quantity={1}
                                                                    className="form-control form-control-sm input-number bg-white"
                                                                    QtyMult={QtyMin}
                                                                    QtyMin={QtyMin}
                                                                    QtyShipped={singleProduct?.shippedQuantity}
                                                                    onChange={(value) => {
                                                                        console.log('Value = ' + value);
                                                                        onValueChange('quantity', value);
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>

                                                <td className='rr-prod-return border-0'>
                                                    <p className='font-13 mb-0'><strong>Reason for return? </strong> </p>
                                                    <div className='mb-3'>
                                                        <div className="form-group">
                                                            <div className="selectbox">
                                                                <select className={`form-control ${detailValidation && detailValidation.reason ? ' error' : ''}`} name="reason" onChange={({ target: { value } }) => onValueChange('reason', value)}>
                                                                    <option value={""}>Select a reason ..</option>
                                                                    {
                                                                        orderReturnReason?.map((item, index) => {
                                                                            return <option key={index} value={item.key}>
                                                                                {item.value}
                                                                            </option>
                                                                        })
                                                                    }
                                                                </select>
                                                            </div>
                                                            {detailValidation.reason && <p className="error"> {detailValidation.reason}</p>}
                                                        </div>
                                                    </div>
                                                    <div className={`upload-file ${detailValidation && detailValidation.file ? ' error' : ''}`}>
                                                        <div className='text-blue2 mb-1'>
                                                            <input type="file" ref={inputRef} id="input-file-upload" onClick={(e) => e.target.value = null} style={{ display: 'none' }} onChange={(e) => handleChange(e)} multiple accept=".xls,.xlsx,.pdf,.doc,.docx,.txt,.csv,.jpg,.jpeg,.png" /><i className="fa fa-upload me-1" aria-hidden="true"></i> <a href={void (0)} className={'text-blue2'} onClick={() => inputRef.current.click()} ><u>Upload a File</u> </a>
                                                        </div>
                                                        {searchData?.file.length > 0 &&
                                                            searchData.file.map((v, i) => (
                                                                <div className='upload-file-name d-flex flex-column'>
                                                                    <div className='d-flex align-items-center mb-1'>
                                                                        {!v?.isError &&
                                                                            <i className="fa fa-check-circle me-1 text-green" aria-describedby="popup-7"></i>
                                                                        }
                                                                        <span className='text-black-stone'>{v?.file.name}</span>
                                                                        <a href={void (0)} className='text-black-stone ms-1' onClick={() => removeFile(i)}> <i className="fa fa-times-circle" aria-hidden="true"></i></a>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                    {detailValidation.file && <p className="error"> {detailValidation.file}</p>}
                                                </td>
                                                <td className='rr-prod-comments border-0'>
                                                    <p className='font-13 mb-0'><strong>{`Comments${searchData?.reason.toLowerCase() === 'others' ? ' (required):' : ':'}`} </strong> </p>
                                                    <div className="form-group">
                                                        <textarea className={`form-control ${detailValidation && detailValidation.comment ? ' error' : ''}`} id="exampleFormControlTextarea1" rows="3" onChange={({ target: { value } }) => onValueChange('comment', value)} maxLength={commentMaxLength} placeholder="Add comment:"></textarea>
                                                        {detailValidation.comment && <p className="error"> {detailValidation.comment}</p>}
                                                        <div className='text-right'>
                                                            <i className='text-black-stone mt-2 font-12 font-arial'>{commentMaxLength - searchData.comment.trim().length > 0 ? commentMaxLength - searchData.comment.trim().length : 0}/{`${commentMaxLength} characters remaining.`} </i>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>


                                </div>
                            </div>
                        </form>
                    </div>

                    {/* Modal footer */}
                    <div className="modal-footer justify-content-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145" data-dismiss="modal" onClick={(() => SetStatus(false))}>
                                cancel
                            </button>
                            {__check(['ORDER_RETURN_REQUEST_API_CALL']).status &&
                                <button type="button" className="bs5 btn btn-primary btn-sm w145" data-dismiss="modal"
                                    disabled={true}>
                                    <i className="fa fa-spinner fa-spin" />
                                </button>
                            }

                            {!__check(['ORDER_RETURN_REQUEST_API_CALL']).status &&
                                <button className="bs5 btn btn-primary btn-sm w145" disabled={validateDisableButton()} onClick={() => onSubmit()}>
                                    submit
                                </button>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrderHistoryReturnRequestPopUp
